import React from 'react';
import { LicenseTracker } from './components/LicenseTracker';
export function App() {
  return <LicenseTracker data-id="element-0" data-mp="35ctrp6chm1d2" />;
}